<ng-container *ngIf="!isLoading else LOADING">
    <ng-container *ngIf="roomExists else NOT_ROOM_EXISTS">
        <ng-container *ngIf="isLoggedIn else NOT_LOGGED_IN">
            <ng-container *ngIf="isTestMode; else NORMAL_ROOM">
                <poker-room-test></poker-room-test>
            </ng-container>
            <ng-template #NORMAL_ROOM>
                <ng-container *ngIf="isPremium">
                    <poker-room-premium></poker-room-premium>
                </ng-container>
                <ng-container *ngIf="!isPremium">
                    <poker-room-not-premium></poker-room-not-premium>
                </ng-container>
            </ng-template>
        </ng-container>
    </ng-container>
</ng-container>




<!--LOADING-->
<ng-template #LOADING>
    <ess-spinner>
        <span i18n>Loading</span>
    </ess-spinner>
</ng-template>

<!--NOT_ROOM_EXISTS-->
<ng-template #NOT_ROOM_EXISTS>
    <div class="container">
        <div class="container-title" i18n>
            Room does not exist
        </div>
        <div class="container-subtitle">
            <span i18n>Sorry, a room with the following number does not exist:</span>
            {{roomIdService.getCurrentRoomID() | room }}
        </div>
    </div>
</ng-template>

<!--NOT_LOGGED_IN-->
<ng-template #NOT_LOGGED_IN>
    <div class="container">
        <div class="container-title" i18n>
            Enter Room
        </div>
        <div class="container-subtitle">
            <span i18n>Provide your name or any pseudonym to enter the scrum poker room </span>
            {{roomIdService.getCurrentRoomID() | room }}.
        </div>
        <div class="container-content">
            <form [formGroup]="enterRoomForm" (ngSubmit)="handleSubmit(enterRoomForm.value)" autocomplete="off"
                novalidate>
                <div class="spo-field-container">
                    <mat-form-field appearance="outline">
                        <mat-label i18n>Display Name</mat-label>
                        <input matInput placeholder="Paul Doe" [formControl]="newDeveloperName" required>
                        <mat-error *ngIf="newDeveloperName.invalid">{{getDeveloperNameErrorMessage()}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="spo-field-container">
                    <button mat-flat-button color="primary" type="submit" i18n class="spo-font-color-white">
                        ENTER ROOM
                    </button>
                </div>
                <div class="spo-field-container cancel">
                    <button mat-raised-button (click)="cancel()" type="button" i18n>
                        CANCEL
                    </button>
                </div>
            </form>
        </div>

        <div class="article-container">
            <mat-divider class="divider"></mat-divider>
            <h2 i18n>
                What you should know about Scrumpoker
            </h2>
            <article-bottom></article-bottom>

        </div>

    </div>
</ng-template>
